import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const PowerIcon = (props: WrappingIconProps) => {
  return (
    <Icon fill="none" {...props}>
      <path
        d="M12 4V10"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M19 12C19 15.866 15.866 19 12 19"
        stroke="currentcolor"
        strokeWidth="2"
      />
      <path
        d="M12 19C8.13401 19 5 15.866 5 12"
        stroke="currentcolor"
        strokeWidth="2"
      />
      <path
        d="M5 12C5 9.99812 5.84034 8.19252 7.1875 6.91669C7.44111 6.6765 7.71269 6.4551 8 6.25469"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M19 12C19 9.62125 17.8135 7.51964 16 6.25469"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
};
